import { getEnumKey } from '@/utils/helper';

export enum PhoneNumberStatus {
  'unchecked',
  'exists',
  'doesNotExist',
  'erroneous',
  'temporarySignUpDone',
}
export enum VerificationOtpType {
  Login = 1,
  Registration,
  PhoneNumberUpdate,
}

export enum QueryKeys {
  productList = 'product-list',
  cartItems = 'cart-items',
  homepageStructure = 'homepage-structure',
  homepageSections = 'homepage-sections',
  homepageSectionsPreview = 'homepage-sections-preview',
  profileData = 'get-profile-data',
  wishlist = 'wishlist',
  searchProduct = 'search-product',
  homePageCollectionProducts = 'homepage-collection-products',
  recentlyViewedProducts = 'recently-viewed-items',
  addressLists = 'address-lists',
  divisionLocation = 'division-location',
  locationLists = 'location-lists',
  megaMenu = 'mega-menu',
  popularSearch = 'popular-search',
  singleModuleProductList = 'module-product-list',
  moduleCustomFilter = 'module-custom-filter',
  moduleBanner = 'module-banner',
  storeLists = 'store-lists',
  getPaymentType = 'get-payment-type',
  orderSummary = 'order-summary',
  getOrders = 'get-orders',
  getOrderDetails = 'get-order-details',
  getInfoGraphic = 'get-info-graphic',
  rewardPoints = 'reward-points',
  rewardPointsTransaction = 'reward-points-transaction',
  voucher = 'voucher',
  brandList = 'brand-list',
  allLocation = 'all-location',
  adPopUp = 'ad-popup',
  memberExclusive = 'member-exclusive',
  memberExclusiveList = 'member-exclusive-list',
  autoComplete = 'auto-complete',
  columnBanners = 'column-banners',
  reorder = 're-order',
  recommendedProducts = 'recommended-products',
  crossCategorySuggestions = 'cross-category-suggestions',
  myLocation = 'my-location-lat-long',
  session = 'session',
  layoutBoundarySession = 'layout-boundary-session',
  ticketList = 'ticket-list',
  emiInfo = 'emi-info',
  getOrderDetailsForDeliveryTypeChange = 'get-order-details-for-delivery-type-change',
  expressZones = 'express-zones',
  giftTemplateCategories = 'gift-template-categories',
  feedbackForm = 'feedback-form',
  feedbackQR = 'feedback-qr',
  giftSettings = 'gift-settings',
  returnExchange = 'return-exchange',
  attachmentUpload = 'attachment-upload',
  purchaseHistory = 'purchase-history',
  myCoupons = 'my-coupons',
  applicableCoupons = 'applicable-coupons',
  collectableCoupons = 'collectable-coupons',
  collectableCouponDisplayDuration = 'collectable-coupon-display-duration',
  rewardBlogEvents = 'reward-blog-events',
  bopisOrderStatus = 'bopis-order-status',
  storeAutoComplete = 'store-auto-complete',
  reward = 'reward',
  applicableObjectiveBasedCampaigns = 'applicable-objective-based-campaigns',
  productBundleAvailability = 'product-bundle-availability',
  productBundlePromotions = 'product-bundle-promotions',
  bundlePromotionBanner = 'bundle-promotion-banner',
  exclusivePrivileges = 'exclusive-privileges',
  exclusivePrivilegeCategories = 'exclusive-privilege-categories',
  announcementBarPopup = 'announcement-bar-popup',
}
export enum BundlePromotionType {
  BuyGroupGetDiscount = 'BuyGroupGetDiscount',
  BuyTriggerGetGroupDiscount = 'BuyTriggerGetGroupDiscount',
  BuyTriggerGetGroupFree = 'BuyTriggerGetGroupFree',
}

export enum BundleTargetType {
  Product = 'Product',
  Category = 'Category',
  Brand = 'Brand',
  Amount = 'Amount',
}
export enum ItemPosition {
  'Left' = 'Left',
  'Right' = 'Right',
}

export enum RefundOption {
  OriginalPayment = 'OriginalPayment',
  StoreVoucher = 'StoreVoucher',
}

export enum ModuleType {
  Category = 'category',
  Brand = 'brand',
}

export enum DeliveryType {
  PickFromStore = 'PickFromStore',
  BOPIS = 'BuyOnlinePickupInStore',
  HomeDelivery = 'StandardDelivery',
  ExpressDelivery = 'ExpressDelivery',
}

export enum OrderType {
  BOPIS = 5,
  EXPRESS = 10,
  REGULAR = 1,
}

export enum ReturnExchangeRequestType {
  Return = 1,
  Exchange = 2,
}

export const REQUEST_TYPE_LABELS: Record<ReturnExchangeRequestType, { url: string; title: string }> = {
  [ReturnExchangeRequestType.Return]: { url: 'return', title: 'Return' },
  [ReturnExchangeRequestType.Exchange]: { url: 'exchange', title: 'Exchange' },
};

export enum ReturnExchangeMethod {
  Courier = 1,
  Store = 2,
}

export enum WidgetViewOptions {
  Slider = 'Slider',
  Grid = 'Grid',
}
export enum Environments {
  'Production' = 'Production',
  'Staging' = 'Staging',
  'Development' = 'Development',
  'Local' = 'Local',
}

export enum BannerTypeOptions {
  Image = 'Image',
  Video = 'Video',
  Collage = 'Collage',
}
export enum ProductCarouselType {
  'Category' = 'Category',
  'Brand' = 'Brand',
}
export enum PreKeyBannerType {
  Image = 'Image',
  Video = 'Video',
}

export enum GiftVoucher {
  gift = 'gift',
  voucher = 'voucher',
}

export enum GiftsModule {
  GiftCategories = 'GiftCategories',
  gifts = 'gifts',
  gift = 'gift',
  voucher = 'voucher',
  customGift = 'custom',
  card = 'card',
}

export enum NeuroMessageType {
  Sales = 'Sales',
  Stock = 'Stock',
}

export enum NeuroMessageScope {
  VariantLevel = 'VariantLevel',
  ProductLevel = 'ProductLevel',
}

export enum HomepageSections {
  CategoryBrandCarousel = 'CategoryBrandCarousel',
  Collections = 'Collections',
  ColumnBanner = 'ColumnBanner',
  KeyBanner = 'KeyBanner',
  PreKeyBanner = 'PreKeyBanner',
  ProductCarousel = 'ProductCarousel',
  Slider = 'Slider',
  Widgets = 'Widgets',
  ProductCarousel2 = 'ProductCarousel2',
  Slider2 = 'Slider2',
  MemberExclusive = 'members-exclusive',
  Testimonial = 'Testimonial',
  Instagram = 'Instagram',
  LimitedTimeOffer = 'Deals',
  AnnouncementBar = 'AnnouncementBar',
  CountdownBanner = 'CountDownBanner',
  AnnouncementBar2 = 'AnnouncementBar2',
}

export enum SocialLoginUrls {
  GoogleLogin = '/google-signin',
  FacebookLogin = '/facebook-signin',
}
export enum AddressType {
  Shipping = 'Shipping',
  Billing = 'Billing',
}

export enum SubOrderStatusBOPIS {
  PickedUp = 'PickedUp',
  Cancelled = 'Cancelled ',
}

export enum SubOrderStatus {
  Placed = 10,
  Processing = 20,
  Confirmed = 30,
  Cancelled = 40,
  Picking = 50,
  Dispatched = 60,
  Shipped = 70,
  Delivered = 80,
  ExchangeRequested = 90,
  RefundInitiated = 100,
  DeliveryFailed = 110,
  PaymentFailed = 120,
  RTOInitiated = 130,
  RTOClosed = 140,
}

export const getSubOrderStatus = (status: number) => {
  return getEnumKey(SubOrderStatus, status);
};

export enum DeviceType {
  Web = 'Web',
  Mobile = 'Mobile',
  Tab = 'Tab',
}

export enum POSAllocationStatus {
  NotRequested = 'NotRequested',
  Requested = 'Requested',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  AllocationFailed = 'AllocationFailed',
}
export enum RewardPointSlab {
  Nil = 'Nil',
  Regular = 'Regular',
  Silver = 'Silver',
  Gold = 'Gold',
  Platinum = 'Platinum',
}

export enum ProductPaymentMode {
  Prepaid = 10,
  COD = 20,
}

export interface IZone {
  ZoneName: string;
  DeliveryCharge: number;
  Stores: IStore[];
}

export interface IStore {
  Id: string;
  LocationRefcode: string;
}

export enum ObjectiveBasedCampaignType {
  MilestoneBased = 'MilestoneBased',
  TierBased = 'TierBased',
  EarlyBird = 'EarlyBird',
  CustomerSegment = 'CustomerSegment',
}

export enum PaymentRestriction {
  Any = 'Any',
  PrepaidOnly = 'PrepaidOnly',
  CODOnly = 'CODOnly',
}

export enum DiscountRuleType {
  CartPromotion = 'CartPromotion',
  SpecialProduct = 'SpecialProduct',
  CouponCode = 'CouponCode',
  ShippingFee = 'ShippingFee',
  SpecialCustomer = 'SpecialCustomer',
  Corporate = 'Corporate',
  CorporateShipping = 'CorporateShipping',
}

export enum MilestoneType {
  PurchaseCount = 'PurchaseCount',
  LifetimeSpend = 'LifetimeSpend',
}

export enum MilestoneRewardType {
  Percentage = 'Percentage',
  FixedAmount = 'FixedAmount',
}